 import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoadingData {
    public incrSubj = new Subject<void>();
    public decrSubj = new Subject<void>();
    public stopSubj = new Subject<void>();
    constructor() { }
}

